import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ASYNC_USER_LOGIN } from 'store';
import { Link, Redirect } from 'react-router-dom';
import { Form, Button, Alert, Row, Col, InputGroup, FormControl } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './style.css';

import { api } from 'services';


import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

const Login = ({ authenticate, login, location, error, loading }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { from } = location.state || { from: { pathname: '/select-area' } };

  const [visibility, setVisibility] = useState({show:false,isVisibility:false})

  const { t } = useTranslation();

  useEffect(()=>{
    document.addEventListener('mousemove',(e)=>{
      let positionx = (e.screenX * 10)/window.innerWidth - 5;
      let positiony = (e.screenY * 10)/window.innerHeight - 5;
      let img = document.getElementById('backgprund-img');
      if(img){
        img.style.marginLeft = `calc(-5px + ${(positionx * -1).toFixed(2)}px)`;
        img.style.marginTop = `calc(-5px + ${(positiony * -1).toFixed(2)}px)`;
      }
    });
  },[]);


  var emailF ='';

  function openPassword(){
    var form2 = document.getElementById('form-2');
    var form1 = document.getElementById('form-1');
    if(form2!=null && form1!=null){
      form2.style.display = 'block';
      form1.style.display = 'none';
    }
  }

  function closePassword(){
    var form2 = document.getElementById('form-2');
    var form1 = document.getElementById('form-1');
    if(form2!=null && form1!=null){
      form2.style.display = 'none';
      form1.style.display = 'block';
    }
  }

  if (authenticate) return <Redirect to={from.pathname} location={location} />;

  return (<>
    <div className="login" id="login">
      <Row className="h-100 p-0 m-0">
        <Col md="5" className="h-100 p-3 m-0 areaForm">
          <div className="login-form">
            <span>
              <img src="/logo-light.png" alt="SCANSOURCE" className="scan-logo" />
            </span>
            {!!error && (
              <Alert className="" variant="danger">
                {error}
              </Alert>
            )}
            <div className="areaForm2">
              <Form
                id="form-1"
                onSubmit={e => {
                  e.preventDefault();
                  login(email, password);
                }}
              >
                <Form.Group>
                  <Form.Label>{t('label:email')}</Form.Label>
                  <InputGroup className="mb-2">
                    <InputGroup.Prepend>
                      <InputGroup.Text>
                        <MailOutlineIcon className="icon-input" />
                      </InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl
                    type="email"
                    placeholder={t('phrase:type your email')}
                    onChange={e => setEmail(e.target.value)}
                    required 
                    />
                  </InputGroup>
                </Form.Group>
                <Form.Group>
                  <Form.Label>{t('label:password')}</Form.Label>
                  <InputGroup className="mb-2">
                    <InputGroup.Prepend>
                      <InputGroup.Text>
                        <LockOutlinedIcon className="icon-input" />
                      </InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl
                    type={visibility.isVisibility?'text':"password"}
                    placeholder={t('phrase:type your password')}
                    onChange={e => {
                      setPassword(e.target.value);
                      setVisibility({...visibility, show:e.target.value.length>0, isVisibility:false});
                    }}
                    required
                    onFocus={()=>{
                      setVisibility({...visibility, show:password.length>0});
                    }}
                    onBlur={()=>{
                      setVisibility({...visibility, show:password.length>0});
                    }}
                    />
                    {!!visibility.show && (<>
                      {!visibility.isVisibility?
                      <VisibilityIcon Icon className="icon-input visibility" 
                      onClick={()=>{
                        setVisibility({...visibility, isVisibility:true});
                        
                      }} />
                      :
                      <VisibilityOffIcon Icon className="icon-input visibility" onClick={()=>{
                        setVisibility({...visibility, isVisibility:false});
                      }} />
                      }
                    </>)}
                  </InputGroup>
                </Form.Group>
                <Form.Group>
                  <Form.Check type="checkbox" label={t('phrase:remember me')} />
                </Form.Group>
                <Button block type="submit" variant="primary-login" className="login-btn" disabled={loading}>
                  Login
                </Button>
                <div className={"loading-bar"+(!loading?' loading-bar-hidden':'')}></div>
                <p className="text-center mt-2">
                  <label className="forgot-password"
                    onClick={e=>{
                      openPassword();
                    }}>
                    {t('phrase:forgot your password')}
                  </label>
                </p>
              </Form>
              <Form
                id="form-2"
                onSubmit={e => {
                  e.preventDefault();
                  document.getElementById('forgot-btn').innerHTML='<div className="loading">Enviando</div>';
                  document.getElementById('forgot-btn').disabled = true;
                  api.post('forgotten-password', { email:emailF} ).then(({ data }) => {
                    if(data.status=='not found'){
                      document.getElementById('forgot-btn').innerHTML='Enviar e-mail';
                      document.getElementById('forgot-btn').disabled = false;
                      document.getElementById('emailHelp').style.display='';
                    }

                    if(data.status=='ok'){
                      document.getElementById('forgot-btn').innerHTML='Enviar e-mail';
                      document.getElementById('forgot-btn').disabled = false;
                      
                      closePassword()
                      //document.getElementById('emailHelp').style.display='';
                    }
                    //window.location.href = location;
                  });
                }}
              >
                <p className="mt-2">
                  <Link className="forgot-password"
                    onClick={
                      closePassword()
                    }>
                    <i className="fas fa-chevron-left"></i> Retornar para o login
                  </Link>
                </p>
                <Form.Group>
                  
                  <Form.Label>{t('label:email')}</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder={t('phrase:type your email')}
                    onChange={e => {
                      emailF=e.target.value;
                      document.getElementById('emailHelp').style.display='none';
                    }}
                    required
                  />
                  <Form.Text style={{height:'10px'}}>
                    <span  id="emailHelp" className="text-danger" style={{display:'none'}}>
                      E-mail não registrado
                    </span >      
                  </Form.Text>
                </Form.Group>
                <Button block type="submit" variant="primary-login" className="forgot-btn" style={{backgroundColor:'#d71925'}} id="forgot-btn">
                  Enviar e-mail
                </Button>
              </Form>
            </div>
          </div>
          <img src="/logo.png" alt="SIM" className="logo-trend-2"/>
        </Col>

        <Col md="7" className="h-100 p-0 m-0 mobileHidden left-area">
          <div id='backgprund-img'></div>
          <img src="/logo-branco-scan.png" alt="SIM" className="logo-trend"/>
        </Col>
      </Row>
    </div>
  </>);
};

const mapStateToProps = state => ({
  authenticate: state.user.authenticate,
  error: state.user.error,
  loading: state.loading,
});

const mapDispatchToProps = dispatch => ({
  login: (email, password) =>
    dispatch({
      type: ASYNC_USER_LOGIN,
      payload: { email, password }
    })
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
